import React from 'react';
import { makeStyles } from '@mui/styles';

import LazyImage from '../../Layouts/LazyImage';

const Hero = ({ data }) => {
  const classes = useStyle();
  return (
    <LazyImage
      sizes={sizes}
      className={classes.heroImg}
      alt={data?.alt}
      src={`/images/courses/project/${data?.img}`}
    />
  );
};

const sizes = {
  xs: [360, 226, false],
  sm: [768, 226, false],
  md: [1024, 226, false],
  xxl: [1600, 226, false],
};

export default Hero;

const useStyle = makeStyles((theme: any) => ({
  heroImg: { height: 120, overflow: 'hidden' },
  [theme.breakpoints.up('sm')]: {
    heroImg: { height: 226 },
  },
}));
